export enum OperationType {
    Created = 'CREATED',
    Updated = 'UPDATED',
    Deleted = 'DELETED',
    SoftDeleted = 'SOFT_DELETED',
    Recovered = 'RECOVERED',
    ScheduledEmailSent = 'ESCALATION_EMAIL_SENT',
    EmailSent = 'EMAIL_SENT',
    CommentEmailSentNotifyResponsible = 'COMMENT_EMAIL_SENT_NOTIFY_RESPONSIBLE',
    CommentEmailSentAssignee = 'COMMENT_EMAIL_SENT_ASSIGNEE',
    StateChanged = 'STATE_CHANGED'
}
